import React from "react";

import CloseIcon from "react-icons/lib/fa/close";
import SearchIcon from "react-icons/lib/fa/search";

import { Input } from "src/components/Form";

import { compose, withHandlers, withState } from "recompose";

import { translate } from "react-i18next";

import { withRouter } from "react-router-dom";

import { withFormik } from "formik";

import { colors } from "src/styles";
import { defaultPrevented } from "src/utils";

import { Box, Flex, Form, A, Link, Text } from "src/components";

const InlineSearchForm = ({
  expanded,
  setExpanded,
  formProps,
  inputProps,
  handleChange,
  handleSubmit,
  setFieldValue,
  t,
  values,
  query,
  reset,
}) => (
  <Form onSubmit={handleSubmit} {...formProps} flex={1}>
    <Flex
      style={{ position: "relative" }}
      justify="center"
      align="center"
      flex={1}
    >
      <Input
        placeholder={t("search.placeholder")}
        onChange={handleChange}
        value={values.search}
        name="search"
        fontWeight="bold"
        autoFocus={true}
        renderLeftIcon={({ style }) => (
          <Flex {...style}>
            <SearchIcon size={18} color={colors.muted} flex={1} />
          </Flex>
        )}
        renderRightIcon={({ style }) => (
          <Flex {...style}>
            <A href="#" onClick={defaultPrevented(reset)}>
              <CloseIcon size={18} color={colors.muted} flex={1} />
            </A>
          </Flex>
        )}
        displayProps={{
          mb: 0,
        }}
        {...inputProps}
      />
    </Flex>
  </Form>
);

const enhance = compose(
  translate("translations"),
  withRouter,
  withFormik({
    mapPropsToValues: props => ({ search: "" }),
    handleSubmit: (values, { props }) => {
      props.history.push(`/search/${encodeURI(values.search)}`);
      props.onClose();
    },
  }),
  withHandlers({
    reset: props => () => {
      props.onClose();
    },
  })
);

export default enhance(InlineSearchForm);



// WEBPACK FOOTER //
// ./src/search/InlineSearchForm.js